import { getTeamUrl } from 'Common'
import getParams from '../Utils/getParams'

export default () => (dispatch, getState) => {

  const state = getState()

  const { mode } = state.screens.Subbies.SubProjects

  const params = getParams(state)

  let url

  if (mode === 'projects') {
    url = 'sub_projects/export?'
  }

  if (mode === 'summary') {
    url = 'sub_projects/export_summary?'
  }

  Object.keys(params).forEach(key => {
    if (params[key] !== undefined) url += `&${key}=${params[key]}`
  })

  window.open(getTeamUrl(url, 'exports'))

}
